import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
    Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const objectOptions = [
    { label: 'Assistência/ Orientação Técnica', value: 'assistencia_orientacao_tecnica' },
    { label: 'Assistência Técnica e Extensão Rural - ATER', value: 'ater' },
    { label: 'Disponibilização de horas-trator/máquina', value: 'horas_trator_maquina' },
    { label: 'Disponibilização de insumos - calcário', value: 'insumos_calcario' },
    { label: 'Disponibilização de insumos - fertilizantes', value: 'insumos_fertilizantes' },
    { label: 'Disponibilização de insumos - sementes', value: 'insumos_sementes' },
    { label: 'Disponibilização de insumos - mudas', value: 'insumos_mudas' },
    { label: 'Disponibilização de insumos - outros', value: 'insumos_outros' },
    { label: 'Apoio à elaboração de cooperação técnica', value: 'cooperacao_tecnica' },
    { label: 'Apoio à elaboração de projetos de crédito rural', value: 'projetos_credito_rural' },
    { label: 'Realização de dias de campo, excursões, cursos, capacitações, seminários, demonstrações técnicas, entre outros eventos', value: 'eventos' },
    { label: 'Programa/projeto/ação voltada ao associativismo e cooperativismo', value: 'associativismo_cooperativismo' },
    { label: 'Programa/projeto/ação voltada ao acesso à água para consumo', value: 'acesso_agua_consumo' },
    { label: 'Programa/projeto/ação voltada à irrigação', value: 'irrigacao' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da apicultura', value: 'cadeia_apicultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da avicultura', value: 'cadeia_avicultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva do arroz na agricultura familiar', value: 'cadeia_arroz' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da cacauicultura', value: 'cadeia_cacauicultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da cafeicultura', value: 'cadeia_cafeicultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da floricultura', value: 'cadeia_floricultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da fruticultura', value: 'cadeia_fruticultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da mandioca', value: 'cadeia_mandioca' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da olericultura', value: 'cadeia_olericultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da pecuária de leite', value: 'cadeia_pecuaria_leite' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da pecuária de corte', value: 'cadeia_pecuaria_corte' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva da piscicultura', value: 'cadeia_piscicultura' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva de Sistemas Agroflorestais (SAFs)', value: 'cadeia_safs' },
    { label: 'Programa/ projeto/ ação voltada à cadeia produtiva de plantas medicinais, aromáticas e condimentares', value: 'cadeia_plantas_medicinais' },
    { label: 'Programa/ projeto/ ação voltada à produção agroecológica', value: 'producao_agroecologica' },
    { label: 'Programa/ projeto/ ação voltada à produção orgânica', value: 'producao_organica' },
    { label: 'Serviço de Inspeção Municipal - SIM', value: 'sim' },
    { label: 'Apoio à realização de feiras (livres e/ou permanentes)', value: 'apoio_feiras' },
    { label: 'Apoio à elaboração de projetos para o Programa Nacional de Alimentação Escolar - PNAE', value: 'projetos_pnae' },
    { label: 'Apoio à elaboração de propostas para o Programa de Aquisição de Alimentos - PAA', value: 'propostas_paa' },
    { label: 'Programa municipal de aquisição de alimentos (com recursos próprios)', value: 'programa_aquisicao_alimentos' },
    { label: 'Programa municipal de compras governamentais (aquisição de produtos da agricultura familiar para atender os órgãos da administração pública', value: 'compras_governamentais' },
    { label: 'Programa/ projeto/ ação voltada à comercialização dos produtos da agricultura familiar nos canais de comercialização convencionais (supermercados, quitandas, restaurantes, bares, lanchonetes, hotéis etc.)', value: 'comercializacao_convencional' },
    { label: 'Programa/ projeto/ ação voltada à comercialização eletrônica dos produtos da agricultura familiar (aplicativos, sites, mídias sociais etc.)', value: 'comercializacao_eletronica' },
    { label: 'Apoio no transporte de produtos da agricultura familiar', value: 'apoio_transporte' },
    { label: 'Cadastro e apoio na emissão de nota fiscal', value: 'cadastro_nota_fiscal' },
    { label: 'Emissão de declaração de produção e localização de estabelecimento agropecuário para beneficiário da reforma agrária com vistas à obtenção de Inscrição Estadual', value: 'declaracao_producao_ie' },
    { label: 'Programa/ projeto/ ação específica para a juventude rural', value: 'juventude_rural' },
    { label: 'Programa/ projeto/ ação específica para as mulheres rurais', value: 'mulheres_rurais' },
    { label: 'Programa/ projeto/ ação específica para os indígenas', value: 'indigenas' },
    { label: 'Programa/ projeto/ ação específica para os quilombolas', value: 'quilombolas' },
    { label: 'Programa/ projeto/ ação específica para outros Povos e Comunidades Tradicionais – PCTs', value: 'pct' },
    { label: 'Programa/ projeto/ ação voltada ao artesanato', value: 'artesanato' },
    { label: 'Georreferenciamento', value: 'georreferenciamento' },
    { label: 'Licenciamento ambiental', value: 'licenciamento_ambiental' },
    { label: 'Cadastro Ambiental Rural - CAR', value: 'car' },
    { label: 'Programa/ projeto/ ação voltada à preservação ambiental', value: 'preservacao_ambiental' },
    { label: 'Programa/ projeto/ ação voltada ao extrativismo de produtos florestais não madeireiros/ sociobiodiversidade', value: 'extrativismo' },
    { label: 'Manejo ambiental', value: 'manejo_ambiental' },
    { label: 'Recuperação/recomposição ambiental de áreas degradadas/alteradas', value: 'recuperacao_ambiental' },
    { label: 'Programa/projeto/ação voltada à Economia Solidária', value: 'economia_solidaria' },
    { label: 'Programa/projeto/ação voltada à Segurança Alimentar e Nutricional', value: 'seguranca_alimentar' },
    { label: 'Emissão de CAF-Pronaf (antiga DAP)', value: 'caf_pronaf' },
    { label: 'Emissão de Certificado de Cadastro de Imóvel Rural - CCIR', value: 'ccir' },
    { label: 'Cadastro e atualização de cadastro de imóvel rural junto ao Incra (SNCR)', value: 'sncr' },
    { label: 'Emissão de certidão para assentados da reforma agrária', value: 'certidao_assentados' },
    { label: 'Regularização de assentados da reforma agrária junto ao Sistema de Informações de Projetos de Reforma Agrária (SIPRA)', value: 'sipra' },
    { label: 'Outros serviços do Incra, mediante cooperação', value: 'incra_outros' },
    { label: 'Serviços relativos ao Imposto Territorial Rural (ITR), mediante convênio com a Receita Federal', value: 'itr' },
    { label: 'Outro', value: 'other' },
];

export interface Demand {
    object: string;
    quantity: number;
    justification: string;
    year: number;
}

export interface Step5CmdrsData {
    demands: Demand[];
}

interface Step5Props {
    hasCmdrs: boolean | null;
    disabled?: boolean;
    onNext: () => void;
    onBack: () => void;
    onChange: (data: Step5CmdrsData) => void;
    data: Step5CmdrsData;
}

const Step5: React.FC<Step5Props> = ({ hasCmdrs, disabled, onNext, onBack, onChange, data }) => {
    const currentYear = new Date().getFullYear();
    const [demands, setDemands] = useState<Demand[]>(data?.demands || []);
    const [openDialog, setOpenDialog] = useState(false);
    const [editIdx, setEditIdx] = useState<number | null>(null);
    const [form, setForm] = useState<Demand>({
        object: '',
        quantity: 1,
        justification: '',
        year: currentYear,
    });
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        onChange({ demands });
        // eslint-disable-next-line
    }, [demands]);

    const handleOpenDialog = (idx?: number) => {
        if (typeof idx === 'number') {
            setForm({ ...demands[idx] });
            setEditIdx(idx);
        } else {
            setForm({
                object: '',
                quantity: 1,
                justification: '',
                year: currentYear,
            });
            setEditIdx(null);
        }
        setErrors({});
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEditIdx(null);
    };

    const handleFormChange = (field: keyof Demand, value: string | number) => {
        setForm(prev => ({
            ...prev,
            [field]: value,
        }));
    };

    const validate = () => {
        const newErrors: { [key: string]: string } = {};
        if (!form.object) newErrors.object = 'Campo obrigatório';
        if (!form.quantity || isNaN(Number(form.quantity)) || Number(form.quantity) < 1 || !Number.isInteger(Number(form.quantity))) {
            newErrors.quantity = 'Informe um número inteiro positivo';
        }
        if (!form.justification) newErrors.justification = 'Campo obrigatório';
        // Se for "Outro", o valor já está em object
        return newErrors;
    };

    const handleAddOrEditDemand = () => {
        const validation = validate();
        setErrors(validation);
        if (Object.keys(validation).length > 0) return;

        if (editIdx !== null) {
            setDemands(prev => prev.map((d, idx) =>
                idx === editIdx
                    ? { ...form, year: currentYear }
                    : d
            ));
        } else {
            setDemands(prev => [
                ...prev,
                { ...form, year: currentYear }
            ]);
        }
        setOpenDialog(false);
        setEditIdx(null);
    };

    const handleDeleteDemand = (idx: number) => {
        setDemands(prev => prev.filter((_, i) => i !== idx));
    };

    const handleSubmit = () => {
        if (demands.length === 0) {
            setErrors({ submit: 'Adicione pelo menos uma demanda.' });
            return;
        }
        setErrors({});
        onNext();
    };

    if (hasCmdrs === false) {
        return (
            <Box>
                <Paper elevation={2} sx={{ p: 3, mb: 4, opacity: 0.6 }}>
                    <Typography variant="h6" gutterBottom>
                        Demandas
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Typography color="text.secondary">
                        Esta aba está desabilitada pois o município não possui CMDRS.
                    </Typography>
                </Paper>
            </Box>
        );
    }

    return (
        <Box>
            <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
                <Typography variant="h6" gutterBottom>
                    Demandas
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <TextField
                    label="Ano de referência do Questionário"
                    value={currentYear}
                    InputProps={{ readOnly: true }}
                    fullWidth
                    margin="normal"
                />

                <Alert
                    severity='info'
                    sx={{ marginY: '2rem', backgroundColor: '#EAEFF9' }}
                >
                    <Typography
                        variant='body2'
                        fontSize='16px'
                        textAlign='left'
                        lineHeight={1.5}
                    >
                        {`Quais são as demandas/necessidades de auxílio em serviços e/ou equipamentos para que esta Secretaria Municipal de Agricultura atenda ao público da agricultura familiar?`}
                    </Typography>
                </Alert>
                <Box display="flex" justifyContent="flex-end" mb={2}>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => handleOpenDialog()}
                        disabled={disabled}
                    >
                        Adicionar demanda
                    </Button>
                </Box>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Objeto</TableCell>
                            <TableCell>Quantidade</TableCell>
                            <TableCell>Justificativa</TableCell>
                            <TableCell>Ano</TableCell>
                            <TableCell>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {demands.map((demand, idx) => (
                            <TableRow key={idx}>
                                <TableCell>
                                    {objectOptions.find(opt => opt.value === demand.object)?.label || demand.object}
                                </TableCell>
                                <TableCell>{demand.quantity}</TableCell>
                                <TableCell>
                                    {demand.justification.length > 80
                                        ? demand.justification.slice(0, 80) + '...'
                                        : demand.justification}
                                </TableCell>
                                <TableCell>{demand.year}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handleOpenDialog(idx)} disabled={disabled}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton onClick={() => handleDeleteDemand(idx)} disabled={disabled}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                        {demands.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    Nenhuma demanda adicionada.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                {errors.submit && (
                    <Typography color="error" sx={{ mt: 1 }}>{errors.submit}</Typography>
                )}

                <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={onBack}
                        disabled={disabled}
                    >
                        Voltar
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={disabled}
                    >
                        Salvar e continuar
                    </Button>
                </Box>
            </Paper>

            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
                <DialogTitle>{editIdx !== null ? 'Editar Demanda' : 'Adicionar Demanda'}</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal" required>
                        <InputLabel id="object-label">Objeto</InputLabel>
                        <Select
                            labelId="object-label"
                            label="Objeto"
                            value={
                                objectOptions.some(opt => opt.value === form.object)
                                    ? form.object
                                    : form.object === '' ? '' : 'other'
                            }
                            onChange={e => {
                                if (e.target.value === 'other') {
                                    handleFormChange('object', '');
                                } else {
                                    handleFormChange('object', e.target.value as string);
                                }
                            }}
                            disabled={disabled}
                        >
                            {objectOptions.map(opt => (
                                <MenuItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.object && <Typography color="error">{errors.object}</Typography>}
                    </FormControl>

                    {!objectOptions.some(opt => opt.value === form.object) && (
                        <TextField
                            label="Nome do Objeto"
                            value={form.object}
                            onChange={e => handleFormChange('object', e.target.value)}
                            error={!!errors.object}
                            helperText={errors.object}
                            fullWidth
                            margin="normal"
                            disabled={disabled}
                            required
                        />
                    )}
                    <TextField
                        label="Quantidade"
                        type="number"
                        value={form.quantity}
                        onChange={e => handleFormChange('quantity', e.target.value)}
                        error={!!errors.quantity}
                        helperText={errors.quantity}
                        fullWidth
                        margin="normal"
                        disabled={disabled}
                        required
                        inputProps={{ min: 1, step: 1 }}
                    />
                    <TextField
                        label="Justificativa"
                        value={form.justification}
                        onChange={e => {
                            if (e.target.value.length <= 500) {
                                handleFormChange('justification', e.target.value);
                            }
                        }}
                        error={!!errors.justification}
                        helperText={
                            errors.justification
                                ? errors.justification
                                : `${form.justification.length}/500 caracteres`
                        }
                        fullWidth
                        margin="normal"
                        disabled={disabled}
                        required
                        multiline
                        minRows={2}
                        inputProps={{ maxLength: 500 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} disabled={disabled}>Cancelar</Button>
                    <Button onClick={handleAddOrEditDemand} variant="contained" disabled={disabled}>Salvar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Step5;